<div class="wrapper sidebar-lg {{sidenavCustom}}" *ngIf="exibir">
    <div *ngIf="!authService.getPrimeiroAcesso()" class="app-sidebar {{bgColor}}" data-active-color="white"
        id="sidebarCustom" data-background-color="vermelho" data-image="assets/img/sidebar-bg/01.jpg">
        <app-sidebar></app-sidebar>
        <div class="sidebar-background"></div>
    </div>

    <app-navbar *ngIf="!authService.getPrimeiroAcesso()" class="fixanavbar {{fixednavbar}}"></app-navbar>
    <div [ngClass]="{'main-panel': !authService.getPrimeiroAcesso()}">
        <div class="main-content" id="main-content"
            [ngClass]="{'m-0' : this.authService.getPrimeiroAcesso() , 'm41' : !this.authService.getPrimeiroAcesso()}">
            <div class="content-wrapper">
                <div class="container-fluid" [ngClass]="{'preCadastro': isPrimeiroAcesso()}">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="page-loading" [ngClass]="{'pageloadingWizard': isPrimeiroAcesso()}">
    <img src="assets/img/oval.svg" class="loading-icon" />
    <span class="load-text">
        {{'Carregando a página'|translate}}
    </span>
</div>